import React, {useCallback, useEffect} from "react";
import { css } from "emotion";
import { NavLink } from "react-router-dom";

import { pagefineshedOffer, pageUnsuccessOffer } from "./style";
import { publish } from "pubsub-js";

import BoxOfferRegistered from "../../../shared/create-offer/BoxOfferRegistered/BoxOfferRegistered";
import BoxInfoRegistered from "../../../shared/create-offer/BoxInfoRegistered/BoxInfoRegistered";
import BoxInfoFinishedOffer from "../../../shared/create-offer/BoxInfoFinishedOffer/BoxInfoFinishedOffer";

import { useNewOffer, clearContext } from "../../context/new-offer";
import { FAMILY_ACCOUNT_BANNER_REGISTERED_OFFER, ROUTE_HOME } from "../../shared/constants";

import eventType from "../../events/eventType";
import { FamilyAccountBanner } from "../../../shared/FamilyAccountBanner/FamilyAccountBanner";

const ResultOffer = props => {
	const {
		offerSentStatus,
		currentProgram,
		offerData,
		isEditOffer,
		editOffer,
		loyaltyData
	} = useNewOffer();

	useEffect(() => {
		if(offerSentStatus.success) {
			registerEvent();
		}
	}, [registerEvent, offerSentStatus])

	const registerEvent = useCallback(() => {
		const { fidelityName, international } = currentProgram;
		const { quant: quantityMiles, price: priceMiles, averageMiles } = offerData?.data;
		const step = isEditOffer ? "edicao-conclusao-oferta" : "conclusao-oferta";
		const { paymentDeadline } = editOffer;
		const { twoFactorAuthenticationStrategy } = loyaltyData.data;

		publish(eventType.OFFER_CONTENT, {
			fidelityName,
			international,
			quantityMiles,
			priceMiles,
			step,
			averageMiles,
			paymentDeadline,
			twoFactorAuthenticationStrategy
		});
	}, [currentProgram, offerData, editOffer, loyaltyData]);

	return offerSentStatus.success ? (
		<div
			className={css`
				${pagefineshedOffer}
			`}
		>
			<FamilyAccountBanner contentType={FAMILY_ACCOUNT_BANNER_REGISTERED_OFFER}/>
			<div className="layout--box-offer-registered">
				<BoxOfferRegistered typePhoneLatam={props.typePhoneLatam} />
			</div>
			<div className="layout--box-info-registered">
				<BoxInfoRegistered typePhoneLatam={props.typePhoneLatam} />
			</div>
			<div className="layout--box-info-finished-offer">
				<BoxInfoFinishedOffer typePhoneLatam={props.typePhoneLatam} />
			</div>
			<div className="layout--box-button">
				<NavLink className={"btn-primary-lg"} to={`${ROUTE_HOME}`} onClick={() => clearContext()} data-action="finished-offer-home" >
					Ir para Minhas ofertas
				</NavLink>
			</div>
		</div>
	) : (
		<div
			className={css`
				${pageUnsuccessOffer}
			`}
		>
			<div className="layout__box-unsuccess">
				<strong>Não conseguimos concluir sua oferta</strong>
				<span>
					Algo deu errado na hora de cadastrar esta oferta. Tente novamente ou entre em contato com
					a gente.
				</span>
				<NavLink to={`${ROUTE_HOME}`} className="btn-primary-lg" onClick={() => clearContext()}>
					Tentar novamente
				</NavLink>
				<div className="box-companies--none--unsuccess" />
			</div>
		</div>
	);
};

export default ResultOffer;
